import React, { useEffect, useState, useRef } from "react";
import LeftIcon from "../assets/LeftIcon.svg";
import RightIcon from "../assets/RightIcon.svg";
import ProposalIcon from "../assets/ProposalIcon.svg";
import Kshema from "../assets/Kshema.svg";
import K from "../assets/KIcon.svg";
import MarketingIcon from "../assets/Department_Icons/Marketing.svg";
import Iticon from "../assets/Department_Icons/IT.svg";
import Call_centerIcon from "../assets/Department_Icons/Customer_Support.svg";
import Sales_DistributionIcon from "../assets/Department_Icons/Sales.svg";
import UnderwritingIcon from "../assets/Department_Icons/Underwriting.svg";
import FAIcon from "../assets/Department_Icons/F&A.svg";
import ActuarialIcon from "../assets/Department_Icons/Actuarial.svg";
import HRIcon from "../assets/Department_Icons/HR.svg";
import LegalIcon from "../assets/Department_Icons/Legal.svg";
import ClaimsIcon from "../assets/Department_Icons/Claim.svg";
import RiskIcon from "../assets/Department_Icons/Risk.svg";
import InvestmentsIcon from "../assets/Department_Icons/Investments.svg";
import GISIcon from "../assets/Department_Icons/GIS.svg";
import ComplainceIcon from "../assets/Department_Icons/Compliance.svg";
import GrevianceIcon from "../assets/Department_Icons/Greviance.svg";
import CRESAIcon from "../assets/Department_Icons/Cresa.svg";
import SecretarialIcon from "../assets/Department_Icons/Secretarial.svg";
import COEIcon from "../assets/Department_Icons/COE.svg";
import Government_BusinesIcon from "../assets/Department_Icons/Govt_Business.svg"; 
import Tele_SalesIcon from "../assets/Department_Icons/Tele_Sales.svg"; 
import PowerBAIcon from "../assets/Department_Icons/power-bi.svg"; 
import PowerBI from "../assets/Department_Icons/power-bi.svg"; 
import GPTIcon from "../assets/Department_Icons/Kshema_GPT.svg"; 
import GrowthIcon from "../assets/Department_Icons/Growth.svg"; 
import { useNavigate } from "react-router-dom";
import { useMsal } from '@azure/msal-react';
import { getFromLocalStorage } from "../../src/utils/Util";
import "./Sidebar.css";
import Avatar from "./Avatar";
// import Avatar from './Avatar';



const departmentIcons = {
  "Marketing": MarketingIcon,
  "IT":Iticon,
  "Call center" : Call_centerIcon,
  "Sales & Distribution" : Sales_DistributionIcon,
  "Underwriting" : UnderwritingIcon,
  "F & A" : FAIcon,
  "Actuarial" :ActuarialIcon,
  "HR" : HRIcon,
  "Legal" : LegalIcon,
  "Claims" : ClaimsIcon,
  "Risk" :RiskIcon,
  "Investments" :InvestmentsIcon,
  "GIS" :GISIcon,
 "Compliance" :ComplainceIcon,
 "Grievance" :GrevianceIcon,
 "CRESA" :CRESAIcon,
 "Secretarial" :SecretarialIcon,
 "COE" :COEIcon,
"Government Business" :Government_BusinesIcon,
"Tele Sales" :Tele_SalesIcon,
"GPT" :GPTIcon,
"BA" :PowerBAIcon,
"PowerBI":PowerBI,
"Growth":GrowthIcon

};

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("User");
  const [userPhoto, setUserPhoto] = useState(null);
  const email = localStorage.getItem("USER_EMAIL");
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  const [reports, setReports] = useState([]);
  const [showUserMenu, setShowUserMenu] = useState(false); 
    const [activeReport, setActiveReport] = useState(null);
  const { instance } = useMsal();
   const dropdownRef = useRef(null);
  const defaultIcon = ProposalIcon;

  useEffect(() => {
    if (email) {
      fetch(`${process.env.REACT_APP_BASE_URL}/get_departments.php?email=${email}`)
        .then(res => res.json())
        .then(data => setDepartments(data))
        .catch(err => console.error(err));
    }
  }, [email]);

   useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowUserMenu(false);
    }
  };
   document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


// useEffect(() => {
//   let rawName = getFromLocalStorage("USER_NAME") || "User";
//   rawName = rawName.split("::")[0].trim(); 
//   const photo = getFromLocalStorage("USER_PHOTO");
//   setUserName(rawName);
//   setUserPhoto(photo);
// }, []);


useEffect(() => {
  let rawName = getFromLocalStorage("USER_NAME") || "User";
  rawName = rawName.split("::")[0].trim(); 
  const photo = getFromLocalStorage("USER_PHOTO");
  setUserName(rawName);
  setUserPhoto(photo && photo !== "null" ? photo : null);
}, []);


  const fetchReports = (dept) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/get_reports_by_department.php?email=${email}&department=${encodeURIComponent(dept)}`)
      .then(res => res.json())
      .then(data => {
        console.log(data, 'data')
        setReports(data)
      }
        
      )
      .catch(err => console.error(err));
  };

 const handleDepartmentClick = (dept) => {
  if (!isOpen) {
    toggleSidebar(); 
    return;
  }

  if (selectedDept === dept) {
   
    setSelectedDept(null);
    setReports([]);
  } else {
    
    setSelectedDept(dept);
    fetchReports(dept);
  }
};

  const handleLogout = () => {
    localStorage.clear();
    instance.logoutRedirect();
  };
const handleReportClick = (dept, reportinternalid) => {
  setActiveReport(reportinternalid);
  localStorage.setItem("selectedDept", dept);
  localStorage.setItem("activeReport", reportinternalid);
  fetch(`${process.env.REACT_APP_BASE_URL}/getReports_2.php?email=${email}&reportinternalid=${reportinternalid}`)
    .then((res) => res.json())
    .then((data) => {
      if (data?.data?.embedToken && data?.data?.embedUrl && data?.data?.reportUrl) {
       
        navigate("/dashboard", { state: data.data });
      } else {
        alert("there is a problem on report.");
      }
    })
    .catch((error) => {
      console.error("Error calling getReports_2.php:", error);
    });
};
  return (
    <div
      className="bg-white shadow p-3 transition-all d-flex flex-column"
      style={{
        width: isOpen ? "300px" : "100px",
        borderTopRightRadius: "40px",
        borderBottomRightRadius: "40px",
        height: "100%",
        position: "relative",
      }}
    >
      {/* Header */}
      <div
        className="d-flex align-items-center justify-content-between mt-3"
        style={{ position: "relative", paddingRight: isOpen ? "40px" : "0px" }}
      >
        <div
          onClick={toggleSidebar}
          style={{
            borderColor: "#d3e4ff",
            minWidth: "64px",
            minHeight: "64px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            zIndex: 1,
          }}
        >
          <img
            src={isOpen ? Kshema : K}
            alt="Logo"
            className={isOpen ? "logo-open" : "logo-closed"}
          />
          {isOpen && <p style={{ fontSize: "20px", fontWeight: "600", paddingTop: "8px", margin: -8, color: "#26354D" }}>Reports</p>}
        </div>
        <button
          onClick={toggleSidebar}
          className="bg-white rounded-2 shadow-sm p-1"
          style={{
            width: "24px",
            height: "33px",
            position: "absolute",
            right: "-26px",
            top: "20px",
            boxShadow: "0 0 4px rgba(80, 130, 209, 0.08)",
            border: "none",
            zIndex: 2,
            cursor: "pointer",
          }}
        >
          <img src={isOpen ? LeftIcon : RightIcon} alt="Toggle Icon" style={{ padding: "3px" }} />
        </button>
      </div>
      {/* Department List */}
     <div className="sidebar-scroll-container mt-2">
  {departments.map((dept) => (
    <div key={dept}>
      {/* Department Item */}
      <div
        className={`d-flex align-items-center p-3 rounded mb-2 department-item ${selectedDept === dept ? "selected" : ""}`}
        style={{
          gap: "8px",
          height: "32px",
          width: isOpen && "246px",
        }}
        onClick={() => handleDepartmentClick(dept)}
      >
        <div className="icon-container-wrapper">
          <img
            src={departmentIcons[dept] || defaultIcon}
            alt={`${dept} Icon`}
            className="icon-image"
          />
        </div>
        {isOpen && (
          <span className="department-label">
            {dept}
            <i
              className={`fas ${selectedDept === dept ? "fa-chevron-down" : "fa-chevron-right"}`}
              style={{ color: "#26354D", marginLeft: "auto" }}
            ></i>
          </span>
        )}
      </div>

      {/* Report List for Selected Department */}
      {selectedDept === dept && isOpen && (
        <div className="mt-3 ps-4 report-list">
          {reports.map((report) => (
            <div
              key={report.reportname}
             className={`report-label ${activeReport === report.userreportinternalid ? 'active' : ''}`}
              onClick={() => handleReportClick(dept, report.userreportinternalid)}
            >
              <span className="bullet">•</span>
              <span className="report-name">{report.reportname}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  ))}
</div>
  
      {/* User Info and Menu */}
      <div className="mt-auto pt-3 border-top position-relative" ref={dropdownRef}>
  <div
    onClick={() => {
      if (!isOpen) {
        toggleSidebar();
        setShowUserMenu(true);
      } else {
        setShowUserMenu(prev => !prev);
      }
    }}
    style={{
      cursor: "pointer",
      fontWeight: "500",
      padding: "10px",
      borderRadius: "8px",
      background: "#f5f5f5",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      justifyContent: isOpen ? "flex-start" : "center",
    }}
  >
    <Avatar name={userName} photoUrl={userPhoto} />
     

    {isOpen && <span>{userName}</span>}
  </div>

  {showUserMenu && (
    <ul
      className="dropdown-menu show"
      style={{
        position: "absolute",
        bottom: "60px",
        left: "10px",
        width: "90%",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        borderRadius: "8px",
        padding: "10px",
        backgroundColor: "#fff",
        zIndex: 10,
      }}
    >
            <li>
              <a className="dropdown-item" href="https://iagri.app/drf" target="_blank" rel="noopener noreferrer">
                Create DRF
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="https://forms.office.com/r/70NmFW3B8N" target="_blank" rel="noopener noreferrer">
                Create FRF
              </a>
            </li>
            {/* <li>
              <a className="dropdown-item" href="#" target="_blank" rel="noopener noreferrer">
                Request Access
              </a>
            </li> */}
            <li>
              <button className="dropdown-item text-danger" onClick={handleLogout}>
                Logout
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
